<template>
  <div class="uuid-panel">
    <h3 class="uuid">{{ uuid }}</h3>
    <button
      class="button"
      @click="handleUUIDv1"
    >Generate V1</button>
    <button
      class="button"
      @click="handleUUIDv4"
    >Generate V4</button>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'; // uuid object is also exported to things
// outside Vue instance.
export default {
  data () {
    return {
      uuid: ''
    };
  },
  created() {
    this.uuid = uuid.v1()
  },
  methods: {
    handleUUIDv1() {
      this.uuid = this.$uuid.v1()
    },
    handleUUIDv4() {
      this.uuid = this.$uuid.v4()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/first.vue